import styled, { keyframes } from 'styled-components';
import backgroundImg from '../../assets/images/background.png';

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

const StyledBackground = styled.div`
  background: url(${backgroundImg}) no-repeat top center;
  background-size: cover;
  background-position: bottom;
  height: 100vh;
  overflow: hidden;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  animation: ${fadeIn} .5s ease-out forwards .1s;

  :after {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-color: rgba(29, 55, 57, 0.8);
  }

  .no-style:hover {
    text-decoration: none;
  }

  @media (max-width: 600px) {
    padding-left: 0;
    padding-right: 0;
    background-color: rgba(29, 55, 57, 0.7);
  }
`;

const StyledDiv = styled.div`
  text-align: left;
  max-width: 700px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  margin-top: 3em;
  align-items: center;

  @media (max-height: 800px) {
    .divLogo {
      width: 520px;
    }
  }

  @media (max-width: 767px) {
    .divLogo {
      margin: 0 auto;
      width: auto;
    }
  }

  @media (max-width: 600px) {
    margin-top: 0;
    position: initial;
    width: 270px;
    height: calc(100vh - 153px);
  }
`;

const TextLogo = styled.div`
  text-transform: uppercase;
  font-size: 42px;
  line-height: 1;
  letter-spacing: 1.6px;
  padding-left: .2em;
  font-family: 'Amorim Sans';

  @media (min-width: 768px) {
    font-size: 108px;
    line-height: 102px;
  }
`;

const StyledText = styled.div`
  margin-top: .7em;
  font-size: 36px;

  @media (max-height: 800px) {
    font-size: 30px;
  }

  @media (max-width: 600px) {
    margin-top: 2.5em;
    font-size: 21px;
    letter-spacing: 2.1px;
    text-align: center;
  }
`;

const StyledSubText = styled.h3`
  font-size: 23px;
  color: #AEDBD9;
  text-align: center;
  margin-top: 6px;

  @media (max-height: 800px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    margin-top: 1em;
    font-size: 13px;
  }
`;

const StyledBorder = styled.div`
  margin-top: 2.4em;
  padding-top: .5em;
  border-top: 1px solid #AEDBD9;
  height: 20px;
  font-size: 18px;
  text-align: center;
  font-style: italic;
  letter-spacing: 2px;

  @media (max-width: 600px) {
    margin-top: .7em;
    font-size: 14px;
    letter-spacing: 1.6px;
  }
`;

const StyledTextDiv = styled.div`
  text-align: center;
`;

const SvgDiv = styled.div`
  height: 120px;
  text-align: center;

  .arrow-right {
    transform: translateX(8px);
    transition: all .15s ease-out;
  }
  &:hover {
    .arrow-right {
      transform: translateX(14px);
    }
  }

  @media ( min-width: 768px) {
    margin-top: 14px;
  }
`;

const StartVisitDiv = styled.div`
  margin-top: 3em;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

const StartVisitText = styled.div`
  position: relative;
  top: -1.5em;
  color: white;
  font-size: 20px;
  transition: .2s ease-in-out;
  letter-spacing: 1.56px;

  > div {
    @media (max-width: 767px) {
      font-size: 22px !important;
    }
  }
`;

export { StyledBackground, StyledDiv, StyledText, StyledSubText, StyledBorder, SvgDiv, StartVisitDiv, TextLogo, StyledTextDiv, StartVisitText }
